import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

import { CommonApiService } from '../shared/common-api.service';
import { LocationModel } from './models/location';

@Injectable({
  providedIn: 'root',
})
export class PlayerService implements OnDestroy {
  subscriptions: Subscription = new Subscription();

  constructor( private commonApiService: CommonApiService) {}

  getWorldTimeRequest(timezone: string) {
    if (environment.apiEndpointParams.test) {
      return throwError('error');
    }
    return this.commonApiService.getRequest<any>(`timezone/${timezone}`);
  }

  getLocationLockStatus(locationGuid: string): Observable<any> {
    return this.commonApiService.getRequest<any>(`locations/${locationGuid}/locked`).pipe(
      catchError(this.commonApiService.handleError),
      map(res => res.payload.isLocked),
      catchError(err => {
        throw err;
      }),
    );
  }

  getLocation(locationGuid: string): Observable<LocationModel> {
    const url = `locations/${locationGuid}?isPlaylists=true`;

    return this.commonApiService.getRequest<any>(url).pipe(map(res => res.payload));
  }

  sendTrackFeedback(audioDetails): Observable<any> {
    return this.commonApiService.postRequest('feedback', audioDetails).pipe(catchError(this.commonApiService.handleError));
  }

  submitWrongRuntime(track, runtime): Observable<any> {
    return this.commonApiService.postRequest('wrongruntime', { track, runtime }).pipe(catchError(this.commonApiService.handleError));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
